export const GET_QNA_LIST = "GET_QNA_LIST"
export const SET_QNA_LIST = "SET_QNA_LIST"
export const ADD_UPDATE_ANSWER = "ADD_UPDATE_ANSWER"
export const SET_QNA_LOADER = "SET_QNA_LOADER"
export const GET_QNA_LOADER = "GET_QNA_LOADER"
export const PUBLISH_QUESTIONS = "PUBLISH_QUESTIONS"
export const DISABLE_QUESTIONS = "DISABLE_QUESTIONS"
export const DOWNLOAD_QUESTIONS = "DOWNLOAD_QUESTIONS"
export const BULK_INSERT_QA = "BULK_INSERT_QA"
export const BULK_PUBLISH_QA = "BULK_PUBLISH_QA"